export default {
  /**
   * 通用
   */
  // 获取导航栏数据
  common_nav: window.API_NAME + '/smart_make_get_info/',
  /**
   * 用户相关
   */
  // 获取个人信息
  user_getmsg: window.API_NAME + '/user_info_new/' + '?T=' + Math.random(),
  /**
   * 智能组卷
   */
  configTest: '/api/Exam/menuList', //-----组卷配置
  zujuanCreat: '/api/Exam/zujuan', //-----组卷生成
  // 获取题目难度
  test_getHard: '/api/Exam/nandu',
}



// WEBPACK FOOTER //
// ./src/request/api.js